exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".signature-container[data-v-1fb5575d]{border:1px solid #ced4da;position:relative}.clear-button[data-v-1fb5575d]{position:absolute;top:0;right:0;cursor:pointer}.sign-guide[data-v-1fb5575d]{position:absolute;top:.5em;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1fb5575d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/documents/SignaturePad.vue
// module id = 1046
// module chunks = 2